<template>
    <span>
        <v-layout align-center @click="openProjectSelector" class="trigger-btn">
            <div style="color: #fff">
                {{activeProject ? activeProject.name : 'Select Campaign'}}
            </div>
            <v-icon color="#fff">mdi-chevron-down</v-icon>
        </v-layout>
    </span>
</template>
<script>
import { mapState } from 'vuex'
import FormMixin from '@/mixins/FormMixin'
import $store from '@/store/store'
import { actionTypes } from '@/store/actionTypes'
import router from '@/router/router'

export default {
    name: 'ToolbarActiveProject',
    mixins: [FormMixin],
    data () {
        return {}
    },
    mounted () {
        this.$appService.loadThenSelectProject()
    },
    computed: {
        ...mapState({
            activeProject: state => state.user.activeProject
        })
    },
    methods: {
        openProjectSelector () {
            this.$appService.selectProject().then(
                project => {
                    this.$store.commit(this.$actionTypes.user.ACTIVE_PROJECT, project)
                }
            )
        }
    }
}
</script>
<style scoped lang="scss">
    .trigger-btn {
        cursor: pointer;
        padding: 5px;
        border-radius: 5px;
        margin-left: 20px;

        &:hover {
            background: #45b9ce;
        }
    }
</style>
